// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3srDg","itemTitle":"ClientEmergencyInfo_itemTitle__3kSvd","itemText":"ClientEmergencyInfo_itemText__3i3Ni"};